import type {ExampleData, DataCallbackOptions} from '../../Common';
import {addPerspectiveCameraOBJWithOrbitControls} from '../../ExampleUtils';

export function createData(options: DataCallbackOptions): ExampleData {
	const {scene} = options;
	const root = scene.root();
	const geo = root.createNode('geo');
	const sphere = geo.createNode('sphere');
	const box = geo.createNode('box');
	const tube = geo.createNode('tube');

	// create a switch
	const switch1 = geo.createNode('switch');
	switch1.setInput(0, sphere);
	switch1.setInput(1, box);
	switch1.setInput(2, tube);

	// create a copy node to instanciate
	// the result of the switch to the points
	// of a plane
	const plane = geo.createNode('plane');
	const attribCreate = geo.createNode('attribCreate');
	const copy = geo.createNode('copy');
	plane.p.size.set([4, 4]);
	copy.setInput(0, switch1);
	copy.setInput(1, attribCreate);
	attribCreate.setInput(0, plane);
	// with a pscale attribute we can vary the scale of the instances
	attribCreate.p.name.set('pscale');
	// this expression will give a random value for each point
	attribCreate.p.value1.set('rand(@ptnum)');
	copy.flags.display.set(true);

	// add a light
	root.createNode('hemisphereLight');

	const {perspectiveCamera1} = addPerspectiveCameraOBJWithOrbitControls(root);

	return {
		scene,
		cameraPath: perspectiveCamera1.path(),
		focusedNodes: [switch1],
		autoLayout: true,
	};
}
// export const sopSwitch = [
// 	new Example({
// 		name: `${ExamplePrefix.BY_NODE}/sop/switch`,
// 		createData,
// 		relatedNodes: [SwitchSopNode],
// 	}),
// ];
